<template>
  <div class="certification">
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section>
      <div class="content page-content">
        <breadcrumb />
                <!--咨询服务-->
        <template v-if="pageId == 6">     
        <div class="content-title">简介</div>  
        <div class="certification-intro certification-intro-area">{{ data.desc }}</div>   
        </template>
        <template  v-if=" data.sections.length">
        <div class="certification-header" :class="{'certification-header-1': data.sections.length == 1}">
            <template v-for="section in data.sections">
            <div class="certification-header-item" :key="'sec'+section.id">
                <div class="content-title">{{ section.name }}</div>
                <div class="certification-header-list" v-if="section.articles.length" >
                    <router-link :to="`/service/article-detail?id=${pageId}&artId=${article.id}`" class="certification-intro" v-for="article in section.articles" :key="'art' + article.id">
                        <span class="certification-intro-title">{{ article.title }}</span>
                        <span class="certification-intro-date">{{ article.createdate ? moment(article.createdate).format('YYYY-MM-DD') : '' }}</span>
                    </router-link> 
                </div>
            </div>
            </template>
        </div>
        </template>




        <!--有案例返回就展示案例-->
        <template v-if="pageId != 5 && data.relatedCases.length"> 
        <div class="content-title">案例展示</div>    
        <div class="certification-case-show">
            <img class="certification-case-show-img" :src="show.img" />
            <div class="certification-case-show-mask">
                <div class="certification-case-show-info">
                    <div class="certification-case-show-info-title">{{ show.title }}</div>
                    <div class="certification-case-show-info-btn" @click="gotoCaseDetail(show)">查看详情</div>
                </div>
            </div>
        </div>
        <imgcard-list @itemClick="gotoCaseDetail" :dataList="data.relatedCases" />
        </template>

        <!--培训&注册-->
        <template v-else-if="pageId == 5 && announceList.length > 0">
            <div class="content-title">公告</div>   
            <dashed-list :list="announceList" link="/service/article-detail?id=5&artId=" />
        </template>

      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "@/components/common/header.vue"
  import menuCmp from "@/components/common/navMenu.vue"
  import footerCmp from "@/components/common/footer.vue"
  import { serviceMenu } from "@/utils/const.js";
  import ImgcardList from "@/components/imgcardList.vue"
  import breadcrumb from "./Breadcrumb.vue"
  import DashedList from "@/components/DashedList.vue"
  import biz from "@/api/biz.js";
  import moment from "moment";

  export default{ 
    data(){ 
      return{ 
        pageId: this.$route.query.id,
        serviceMenu,
        title: serviceMenu[this.$route.query.id].name,
        data: {sections: [], relatedCases: []},
        announceList: [],
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp,
      ImgcardList,
      breadcrumb,
      DashedList
    },
    methods:{ 
      moment,
      gotoDetail(item){ 
        this.$router.push(`/service/article-detail?id=${this.pageId}&artId=${item.id}`)
      },
      gotoCaseDetail(item){
        this.$router.push(`/service/article-detail?id=${this.pageId}&artId=${item.id}&type=case`)
      },
      getContent(){
            const id = this.pageId;
            biz.fetch({
                name: serviceMenu[id].name                
            }).then(res=>{
                const data = res.data;
                if(data){
                    if(id == 5 && data.sections.length){
                        var announces = data.sections.filter(i=>i.name == '公告');
                        if(announces && announces.length > 0){
                            this.announceList = data.sections.filter(i=>i.name == '公告')[0].articles;
                           
                        }
                        data.sections = data.sections.filter(i=>i.name != '公告');
                    }
                    if(data.relatedCases.length){
                        this.show = data.relatedCases[0];
                    }
                    this.data = data;
                }             
            })
      }
    },
    mounted(){ 
        this.getContent();
    },
    watch: {
        $route() {
            this.pageId = this.$route.query.id;
            this.getContent()
        }
    },
  }
</script>

<style lang="scss" scoped>
.certification{
  .content{
    .certification-header{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        flex-wrap: wrap;
        &-item{
            width: 49.375%;
        }
        &-list{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
    }
    .certification-intro{
        display: flex;
        text-decoration: none;
        justify-content: space-between;
        color: #333;
        width: 100%;
        box-shadow: 0 0 10px 0 rgba(184, 184, 184, 0.6) ;
        border: 2px  #222;
        font-size: 16px;
        height: 82px;
        line-height: 82px;
        box-sizing: border-box;
        padding: 0 20px;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;   
        margin-bottom: 10px;
        &-title{
            overflow: hidden;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        &-date{
            float: right;
            color: #ddd;
        }
    }
    .certification-intro-area.certification-intro{
        word-wrap: break-word;
        white-space: normal;
        height: auto;
        line-height: 1.7;
        padding-top: 20px;
        padding-bottom: 20px;
        display: block;
        word-break: break-all;
    }
    .certification-header-1{
        .certification-header-item{
            width: 100%;
        }
        .certification-header-list .certification-intro{
            width: 49.5%;
        }
    }
    .content-title{
        font-size: 28px;
        color: #222222;
        line-height: 1;
        padding: 40px 0 30px;
        box-sizing: border-box;
        font-weight: 500;
    }
    .content-title-hidden{
        visibility:hidden;
    }
    .certification-case-show{
        overflow: hidden;
        border-radius: 8px;
        height: 0;
        padding-top: 54%;
        position: relative;
        margin-bottom: 30px;
        &-img{
            width: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        &-mask{
            border-radius: 8px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%);
            .certification-case-show-info{
                position: absolute;
                bottom: 40px;
                left: 40px;
                color: #fff;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 40px;
                &-btn{
                    width: 224px;
                    height: 52px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #333333;
                    line-height: 52px;
                    margin-top: 16px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
  }
}

@media screen and (max-width:960px){
    .certification{
        .certification-header{
            margin-bottom: .16rem;
            flex-wrap: wrap;
            .certification-header-item{
                width: 100%;
                .certification-intro-date{
                    display: block;
                }
            }
        }
        .content{
            .certification-header-list .certification-intro{
                font-size: .14rem;
                line-height: .20rem;
                border: none;
                word-break: break-all;
                white-space: normal;
                padding: .16rem .1rem .12rem;
                border-top: 1px solid #F1F1F1;
                height: auto;
                flex-wrap: wrap;
                border-bottom: 1px solid #F1F1F1;
            }
            .certification-header-1 .certification-header-list .certification-intro{
                width: 100%;
            }
            .content-title{
                font-size: .18rem;
                line-height: .24rem;
                padding: .16rem 0;
            }
            .certification-intro-area.certification-intro{
                padding-top: .2rem;
                padding-bottom: .2rem;
                font-size: .16rem;
            }
            .certification-intro-title{
                width: 100%;
            }
            .content-title-hidden{
                display: none;
            }
            .content-title-hidden + .certification-intro{
                border-top: none;
            }
            .certification-case-show{
                // height: 1.42rem;
                margin-bottom: .02rem;
                &-mask{
                    .certification-case-show-info{
                        bottom: .12rem;
                        left: .12rem;
                        &-title{
                            font-size: .16rem;
                            line-height: .22rem;
                        }
                        &-btn{
                            width: .72rem;
                            height: .30rem;
                            line-height: .30rem;
                            font-size: .12rem;
                            margin-top: .08rem;
                        }
                    }
                }
            }
        }
    }
}
</style>

